import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux'
import { GET_CLIENT_TERMS } from '../../store/actions/termsPrivacy';
import Aux from "../../hoc/_Aux";
import Card from "../../App/components/MainCard";
import withRouter from '../../App/components/withRouter';
import { PORTAL_INSTANCE } from '../..';
const mapStateToProps = (state, ownProps) => {
    return {
        termsPrivacy: state.termsPrivacy.termsPrivacyDetail
    }

}

const mapDispatchToProps = (dispatch) => {
    return {
        GET_CLIENT_TERMS: (payload) => dispatch(GET_CLIENT_TERMS(payload)),
    }
}

class Policy extends Component {


    componentDidMount() {
        const payload = {
            portalId: PORTAL_INSTANCE.pId,
            clientId: PORTAL_INSTANCE.cId,
        }
        this.props.GET_CLIENT_TERMS(payload)
    }

    render() {
        const { termsPrivacy } = this.props
        return (
            <Aux>
                <Row>
                    <Col>
                        <Card title='Privacy Policy'>
                            {termsPrivacy ? <div dangerouslySetInnerHTML={{ __html: termsPrivacy.privacyPolicy }} /> : null}
                        </Card>
                    </Col>
                </Row>
            </Aux>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Policy));